document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.learning-filters button');
  const categories = document.querySelectorAll('.learning-category-section');

  buttons.forEach(button => {

    button.addEventListener('click', () => {

      buttons.forEach(btn => btn.classList.remove('active'));

      button.classList.add('active');

      const filter = button.dataset.filter;

      categories.forEach(category => {

        if (filter === 'all') {

          category.style.display = 'block';

          return;

        }

        if (category.dataset.category === filter) {

          category.style.display = 'block';

        } else {

          category.style.display = 'none';

        }

      });

    });

  });

});